import * as React from 'react';
import media from './fpp_media_queries';
import styled from 'styled-components';
import TextComponent from './text_component';
import RecommendedProductsWrapper from '../../related-products-wrapper.js';
import { useSelectedOption, useInternationalBuyBox } from '../../shared-state.js';

const HeadingContainer = styled.div`
   padding-bottom: 40px;
   ${media.mobileLandscapeAll} {
      padding-bottom: 20px;
   }
`;

function RelatedProductsComponent(props) {
   const [option] = useSelectedOption();
   const [internationalBuyBox] = useInternationalBuyBox();
   const activeProps = option && props.relatedByOptionid[option.optionid];

   if (!activeProps || option.avail < 1 || internationalBuyBox === true) {
      return null;
   }

   return (
      <React.Fragment>
         <HeadingContainer>
            <TextComponent subheading={_js('Frequently Bought Together')} />
         </HeadingContainer>
         <RecommendedProductsWrapper activeProps={activeProps} />
      </React.Fragment>
   );
}

export default RelatedProductsComponent;
